import { useQuery } from "@tanstack/react-query";

import { USER_IDENTITY_DATA_KEY } from "../api/user/config";
import { useUserApi } from "../api/user/useUserApi";
import { UserIdentity } from "../api/user/user";

type UseUserDataProps = {
  userIdentityData: UserIdentity | undefined;
};

export const useUserData = (): UseUserDataProps => {
  const { getUserIdentity } = useUserApi();

  const { data: userIdentityData } = useQuery({
    queryKey: [USER_IDENTITY_DATA_KEY],
    queryFn: getUserIdentity,
  });

  return {
    userIdentityData,
  };
};
